import React from 'react';
import { Avatar, Dropdown, Menu } from 'antd';
import { useTranslation } from "react-i18next";
import i18n from '../../i18n';

const Lang = () => {
    const { t } = useTranslation();
    const mobile = window.innerWidth < 768;

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const languages = {
        ar: "العربية",
        fr: "Français",
        en: "English",
        es: "Español",
        tr: "Türkçe",
        ru: "Русский",
        pt: "Português",
        nl: "Nederlands",
        de: "Deutsch",
        it: "Italiano",
        zh: "中文"
    };

    const menu = (
        <Menu>
            {Object.entries(languages).map(([code, name], index) => (
                <Menu.Item key={index}>
                    <div 
                        className="dropdown-item text-dark d-flex align-items-center" 
                        onClick={() => changeLanguage(code)}
                        style={{ cursor: 'pointer' }}
                    >
                        <img width="15px" src={`/images/flags/${code}.png`} alt={code} />
                        <span className="mt-1 ms-2" >{name}</span>
                    </div>
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <Dropdown overlay={menu} placement="bottomRight" style={{ color:"var(--primary-color233) !important", }} >
            <div className="hdr-ctrl hdr-lang" style={{ cursor: "pointer" }}>
                <Avatar
                    size={30}
                    src={`/images/flags/${i18n.language}.png`}
                />
                {!mobile && (
                    <span>{languages[i18n.language] || i18n.language}</span>
                )}
            </div>
        </Dropdown>
    );
};

export default Lang;